export const FirebaseConfig = {
	"projectId": "fife-taxi-app",
	"appId": "1:164717089177:web:52a6ef5b6544d7dabfc308",
	"databaseURL": "https://fife-taxi-app-default-rtdb.firebaseio.com",
	"storageBucket": "fife-taxi-app.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyA_v_7iuuCXnPDBEkmM8KTaqqYjaMH9zAc",
	"authDomain": "fife-taxi-app.firebaseapp.com",
	"messagingSenderId": "164717089177",
	"measurementId": "G-95BED2JENW"
};